import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { BaseComponent } from '@lib/components';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAuthResponse, IError, IUser } from '@lib/interfaces';
import { ITransferResponse } from '@lib/interfaces/transfer.interface';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
    template: '',
})
export class SharedPeerToPeerSuccessComponent extends BaseComponent {
    recipientInfo: IUser; // receiver's info
    userInfo: IAuthResponse['admin']; // sender info
    transferResponse: ITransferResponse;
    errorDetails: IError;
    isMoneySent: boolean;

    @ViewChild('pdfExport', { static: false }) pdfTable: ElementRef;

    constructor(public dialogRef: MatDialogRef<SharedPeerToPeerSuccessComponent>, @Inject(MAT_DIALOG_DATA) public data: { moneySent: boolean }) {
        super();
    }

    protected handleDownloadPdf() {
        const element = this.pdfTable.nativeElement;

        html2canvas(element).then((canvas) => {
            const doc = new jsPDF('p', 'mm', 'a4');
            const imgData = canvas.toDataURL('image/png');
            doc.addImage(imgData, 'PNG', 10, 10, 180, 280);
            doc.save('send-money.pdf');
        });
    }

    protected retryFundsTransfer() {
        this.dialogRef.close();
    }
}
